import EdiOperator from "@/domains/EdiOperators/EdiOperator";
import EdiOperatorsDAO from "@/domains/EdiOperators/EdiOperatorsDAO";
import Utils from "@/core/utils/Utils";
import Dictionary from "@/core/types/Dictionary";

class EdiOperatorsService {

    /**
     * Кеш EDI-операторов. Наполняется из Dictionaries общим эндпоинтом.
     * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
     */
    static ediOperators = reactive(new Dictionary<number, EdiOperator>());

    static async getList(): Promise<EdiOperator[]> {
        const response = await EdiOperatorsDAO.getList();

        return Utils.isNotEmptyArray(response.data)
            ? response.data.map((item: any) => EdiOperator.fromServer(item))
            : [];
    }
}

export default EdiOperatorsService;